import {
  LIST_REQUEST,    LIST_RESPONSE,    LIST_FAILURE,
  DETAIL_REQUEST,  DETAIL_RESPONSE,  DETAIL_FAILURE,
  PREVIEW_REQUEST, PREVIEW_RESPONSE, PREVIEW_FAILURE,

  CREATE_REQUEST,  CREATE_SUCCESS,   CREATE_FAILURE,
  UPDATE_REQUEST,  UPDATE_SUCCESS,   UPDATE_FAILURE,
  DELETE_REQUEST,  DELETE_SUCCESS,   DELETE_FAILURE,

  SUBSCRIBE_REQUEST, SUBSCRIBE_SUCCESS, SUBSCRIBE_FAILURE,
  CANCEL_REQUEST,    CANCEL_SUCCESS,    CANCEL_FAILURE,
  SUBSCRIPTIONS_REQUEST, SUBSCRIPTIONS_RESPONSE, SUBSCRIPTIONS_FAILURE,

  MY_LISTINGS_REQUEST, MY_LISTINGS_RESPONSE, MY_LISTINGS_FAILURE,
  EARNINGS_REQUEST,    EARNINGS_RESPONSE,    EARNINGS_FAILURE,

  PUBLISHED_SIGNALS_REQUEST, PUBLISHED_SIGNALS_RESPONSE, PUBLISHED_SIGNALS_FAILURE,
  SELLER_STATUS_REQUEST,  SELLER_STATUS_RESPONSE,  SELLER_STATUS_FAILURE,
  PROVIDER_APPLY_REQUEST, PROVIDER_APPLY_SUCCESS,  PROVIDER_APPLY_FAILURE,

  CLEAR_MUTATIONS,
} from '../../actions/marketplace/listings';

// One reducer per visual surface. Each is a small {response, isLoading,
// error} shape so connect() boilerplate stays minimal across all
// marketplace screens.
const baseInit = { response: null, isLoading: false, error: null };

const make = (req, res, fail) => (state = baseInit, action) => {
  switch (action.type) {
    case req:  return { ...state, isLoading: true, error: null };
    case res:  return { ...state, isLoading: false, response: action.payload };
    case fail: return { ...state, isLoading: false, error: action.payload };
    default:   return state;
  }
};

export const list          = make(LIST_REQUEST,    LIST_RESPONSE,    LIST_FAILURE);
export const detail        = make(DETAIL_REQUEST,  DETAIL_RESPONSE,  DETAIL_FAILURE);
export const preview       = make(PREVIEW_REQUEST, PREVIEW_RESPONSE, PREVIEW_FAILURE);
export const subscriptions = make(SUBSCRIPTIONS_REQUEST, SUBSCRIPTIONS_RESPONSE, SUBSCRIPTIONS_FAILURE);
export const myListings    = make(MY_LISTINGS_REQUEST,   MY_LISTINGS_RESPONSE,   MY_LISTINGS_FAILURE);
export const earnings      = make(EARNINGS_REQUEST,      EARNINGS_RESPONSE,      EARNINGS_FAILURE);
export const publishedSignals = make(PUBLISHED_SIGNALS_REQUEST, PUBLISHED_SIGNALS_RESPONSE, PUBLISHED_SIGNALS_FAILURE);
export const sellerStatus  = make(SELLER_STATUS_REQUEST, SELLER_STATUS_RESPONSE, SELLER_STATUS_FAILURE);

// Mutation reducer: tracks a single in-flight CRUD/sub action so the
// dialog / detail page can render busy + success/error chips.
const mutInit = {
  isLoading: false,
  action:    null,    // 'create' | 'update' | 'delete' | 'subscribe' | 'cancel' | 'providerApply'
  result:    null,
  error:     null,
};

export const mutations = (state = mutInit, action) => {
  switch (action.type) {
    case CREATE_REQUEST:    return { ...state, isLoading: true, action: 'create',    error: null };
    case UPDATE_REQUEST:    return { ...state, isLoading: true, action: 'update',    error: null };
    case DELETE_REQUEST:    return { ...state, isLoading: true, action: 'delete',    error: null };
    case SUBSCRIBE_REQUEST: return { ...state, isLoading: true, action: 'subscribe', error: null };
    case CANCEL_REQUEST:    return { ...state, isLoading: true, action: 'cancel',    error: null };
    case PROVIDER_APPLY_REQUEST:
      return { ...state, isLoading: true, action: 'providerApply', error: null };

    case CREATE_SUCCESS:
    case UPDATE_SUCCESS:
    case DELETE_SUCCESS:
    case SUBSCRIBE_SUCCESS:
    case CANCEL_SUCCESS:
    case PROVIDER_APPLY_SUCCESS:
      return { ...state, isLoading: false, result: action.payload };

    case CREATE_FAILURE:
    case UPDATE_FAILURE:
    case DELETE_FAILURE:
    case SUBSCRIBE_FAILURE:
    case CANCEL_FAILURE:
    case PROVIDER_APPLY_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case CLEAR_MUTATIONS:   return mutInit;
    default:                return state;
  }
};
